/**
 * Endpoints for the Core::Catalog benef API.
 *
 * Base URL is /api/benef (set in VITE_API_URL), so paths here are relative
 * to that prefix.
 */
const CATALOG_PATH = "/catalog";

export const RENTALS_API_ENDPOINTS = {
  GET_COLLECTIONS: `${CATALOG_PATH}/collections`,
  GET_COLLECTION: `${CATALOG_PATH}/collections/:collectionId`,
  GET_ITEMS: `${CATALOG_PATH}/items`,
  GET_ITEM: `${CATALOG_PATH}/items/:itemId`,
  // Iso `Campings::AvailableDatesService` : datepicker contraint pour
  // les kind: hebergement. Sans param → dates d'arrivée distinctes ;
  // avec `?check_in_date=YYYY-MM-DD` → dates de départ proposées pour
  // cette arrivée.
  GET_AVAILABLE_DATES: `${CATALOG_PATH}/items/:itemId/available_dates`,
  // Quota par saison de la collection de l'article, déjà consommé et
  // restant pour le salarié connecté (saisons non terminées seulement).
  GET_SEASON_QUOTA_USAGE: `${CATALOG_PATH}/items/:itemId/season_quota_usage`,
  // Cart unifié (Phase 1+) : un seul cart `open` par bénéf qui
  // agrège ses N bookings. Endpoint d'entrée pour la page panier et
  // le checkout multi-bookings (Paybox session unique ou pay-later).
  GET_CART_CURRENT: `${CATALOG_PATH}/carts/current`,
  UPDATE_CART: `${CATALOG_PATH}/carts/:cartId`,
  CHECKOUT_CART: `${CATALOG_PATH}/carts/:cartId/checkout`,
  EMPTY_CART: `${CATALOG_PATH}/carts/:cartId/empty`,
  UPDATE_CART_SUBSIDY_CHOICES: `${CATALOG_PATH}/carts/:cartId/subsidy_choices`,
  GET_BOOKINGS: `${CATALOG_PATH}/bookings`,
  GET_BOOKING: `${CATALOG_PATH}/bookings/:bookingId`,
  CREATE_BOOKING: `${CATALOG_PATH}/bookings`,
  CONFIRM_BOOKING: `${CATALOG_PATH}/bookings/:bookingId/confirm`,
  CANCEL_BOOKING: `${CATALOG_PATH}/bookings/:bookingId/cancel`,
  PREVIEW_PAYMENT: `${CATALOG_PATH}/bookings/:bookingId/preview_payment`,
  INITIATE_PAYMENT: `${CATALOG_PATH}/bookings/:bookingId/initiate_payment`,
  UPDATE_SUBSIDY_CHOICES: `${CATALOG_PATH}/bookings/:bookingId/subsidy_choices`,
  ACCOUNT_STATEMENT: `${CATALOG_PATH}/account_statement`,
  GET_CATEGORIES_FOR_COLLECTION: `${CATALOG_PATH}/collections/:collectionId/categories`,
};
